const productos = {
  Antibióticos: [
    { alias: 'Biofixima', nombreCompleto: 'Biofixima 400mg', variantes: ['Biofixima 400mg'] },
    { alias: 'Bioproxina', nombreCompleto: 'Bioproxina 500mg', variantes: ['Bioproxina 500mg'] },
    { alias: 'Cebiodroxilo', nombreCompleto: 'Cebiodroxilo 500mg', variantes: ['Cebiodroxilo 500mg'] },
    { alias: 'Zitrobio', nombreCompleto: 'Zitrobio', variantes: ['Zitrobio', 'Zitrobio 15ML', 'Zitrobio 30ML', 'Zitrobio 500mg'] },
  ],
  Cardiometabólica: [
    { alias: 'Ambiodipina', nombreCompleto: 'Ambiodipina', variantes: ['Ambiodipina', 'Ambiodipina 10mg', 'Ambiodipina 5mg'] },
    { alias: 'Atorvastatin', nombreCompleto: 'Atorvastatin', variantes: ['Atorvastatin', 'Atorvastatin 20mg', 'Atorvastatina 40mg'] },
    { alias: 'Biozartan', nombreCompleto: 'Biozartan', variantes: ['Biozartan'] },
    { alias: 'Bioprolol', nombreCompleto: 'Bioprolol', variantes: ['Bioprolol', 'Bioprolol 2.5mg', 'Bioprolol 5mg'] },
    { alias: 'Biodipina LP', nombreCompleto: 'BiodipinaLP', variantes: ['BiodipinaLP'] },
    { alias: 'Bionapril', nombreCompleto: 'Bionapril', variantes: ['Bionapril', 'Bionapril 10mg', 'Bionapril 5mg'] },
    { alias: 'Biotelmic', nombreCompleto: 'Biotelmic', variantes: ['Biotelmic', 'Biotelmic 40mg', 'Biotelmic 80mg'] },
    { alias: 'Carbiolol', nombreCompleto: 'Carbiolol', variantes: ['Carbiolol', 'Carbiolol 25mg', 'Carbiolol 6,25mg'] },
    { alias: 'Glimebio', nombreCompleto: 'Glimebio', variantes: ['Glimebio', 'Glimebio 2mg', 'Glimebio 4mg'] },
    { alias: 'Hidrobiozida', nombreCompleto: 'Hidrobiozida', variantes: ['Hidrobiozida'] },
    { alias: 'Metforbio', nombreCompleto: 'Metforbio', variantes: ['Metforbio'] },
    { alias: 'Olmebloc', nombreCompleto: 'Olmebloc', variantes: ['Olmebloc', 'Olmebloc 20mg', 'Olmebloc 40mg'] },
    { alias: 'Rosuvastatin', nombreCompleto: 'Rosuvastatin', variantes: ['Rosuvastatin', 'Rosuvastatin 20mg', 'Rosuvastatin 40mg'] },
  ],

  Respiratoria: [
    { alias: 'Chamber', nombreCompleto: 'Chambers', variantes: ['Chamber Sistema Flow-Vu'] },
    { alias: 'Ciclesona-T', nombreCompleto: 'Ciclesona-T', variantes: ['Ciclesona-T'] },
    { alias: 'DeslonilMt', nombreCompleto: 'DeslonilMt', variantes: ['DeslonilMt 5mg', 'DeslonilMt 10mg'] },
    { alias: 'Ventiduo-Plus', nombreCompleto: 'Ventiduo-Plus', variantes: ['Ventiduo-Plus'] },
  ],

  Otros: [
    { alias: 'Betahistina', nombreCompleto: 'Biotahistin', variantes: ['Biotahistin'] },
    { alias: 'Bioez', nombreCompleto: 'Bioez', variantes: ['Bioez', 'Bioez 20mg', 'Bioez 40mg'] },
    { alias: 'Bioflazacort', nombreCompleto: 'Bioflazacort', variantes: ['Bioflazacort'] },
    { alias: 'Biogavalina', nombreCompleto: 'Biogavalina', variantes: ['Biogavalina', 'Biogavalina 150mg', 'Biogavalina 75mg'] },
    { alias: 'Biosulfil (crema)', nombreCompleto: 'Biosulfil', variantes: ['Biosulfil'] },
    { alias: 'Biotamsul', nombreCompleto: 'Biotamsul', variantes: ['Biotamsul'] },
    { alias: 'Flubionazol', nombreCompleto: 'Flubionazol', variantes: ['Flubionazol'] },
    { alias: 'Flunarazina', nombreCompleto: 'Fludisina', variantes: ['Fludisina'] },
    { alias: 'Pantobio Plus', nombreCompleto: 'Pantobio', variantes: ['Pantobio'] },
    { alias: 'Quetiapina', nombreCompleto: 'Quetiapine', variantes: ['Quetiapine', 'Quetiapine 100mg', 'Quetiapine 50mg'] },
  ],
};

// Función helper para obtener todos los productos permitidos (nombres completos base)
export const getProductosPermitidos = () => {
  return Object.values(productos)
    .flat()
    .map(producto => producto.nombreCompleto);
};

// Función helper para obtener productos para modales (incluye todas las variantes)
export const getProductosModal = () => {
  return Object.values(productos)
    .flat()
    .flatMap(producto => producto.variantes || [producto.nombreCompleto]);
};

// Array de productos para modales (compatibilidad con código existente)
export const productosModal = getProductosModal();

export default productos;
